import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from './slice'

export const useProducts = () => {
  const dispatch = useDispatch()

  return {
    ...bindActionCreators(actions, dispatch),
    ...useSelector(state => state.supplier.products),
  }
}
